import { useMemo } from "react";
import { useAuthStore } from "../../stores/useAuthStore";
import type { PlatformRole } from "../../lib/rbac";

export function useCurrentRole(): PlatformRole | null {
  const user = useAuthStore((state) => state.user);
  return useMemo(() => {
    const raw =
      (user?.platformRole as string) || (user?.platform_role as string) || null;
    return raw ? (raw.toLowerCase() as PlatformRole) : null;
  }, [user]);
}
